import React from 'react';
import { useSnapshot } from 'valtio';

import '../../www/assets/css/data_readout.css';

import { datareadStore, videoStore, refsStore } from '../managers/globalState';


/**
 * Sets the position and value in the global dataread store
 * @param {string|null} readValue
 * @param {string|null} readLatLonValue
 * @param {Vector2} position
 */
const setReadoutData = (readValue, readLatLonValue, position) => {
	const isValid = readValue !== null && readLatLonValue !== null && position?.x && position.y;
	
	let left = -200;
	let top = -200;
	let value = '';
	let valueLatLon = ''

	if (isValid) {
		left = position.x + 10;
		top = position.y - 10;
		value = readValue;
		valueLatLon = readLatLonValue;
	}

	// Set global store.
	datareadStore.setGlobalState({
		readoutData: {
			position: { left, top },
			value,
			valueLatLon
		}
	});
};

const DataReadout = () => {
	const { readoutData } = useSnapshot(datareadStore.state);
	const { position, value, valueLatLon } = readoutData || {};
	const { videoId } = useSnapshot(videoStore.state);
	const { get } = refsStore.stateSnapshot;
	const videoType = get('video').getVideoType(videoId);

	const style = {
		position: 'absolute',
		...position,

	};
	// add latlon positions -zahrah
	const styleLatLon = {
		position: 'absolute',
		direction: 'ltr',
		left: position && position.left ? position.left : null,
		top: position && position.top ? position.top + 30 : null
	}
	console.log('position', position)

	return (
		<div id='data-canvas-container' className='data-canvas-container showUI'>
			{ videoType !== 'global' && <div id='data-cursor-readout' className='data-cursor' style={style}>{value}</div> }
			{ videoType !== 'global' && <div id='data-cursor-readout' className='data-cursor' style={styleLatLon}>{valueLatLon}</div> }
			<canvas id='data-canvas' className='hidden' width='1440' height='720' />
		</div>
		

	);
};

export default DataReadout;
export { setReadoutData };
